export const MY_ORGANIZATION_ID = 'my';
